import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded'
import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import { useTranslation } from 'react-i18next'

import { getGarageParkingEndMessage, type GarageParkingPeriod } from '../garage-parking-period'

export default function MinimumStayNotice({
    parkingPeriod,
    compact = false,
}: {
    parkingPeriod: GarageParkingPeriod,
    compact?: boolean,
}) {
    const { t } = useTranslation()

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: compact ? 0.75 : 1.25,
            border: compact ? '1px solid var(--joy-palette-neutral-100)' : 'none',
            borderRadius: compact ? 10 : 0,
            p: compact ? 1 : 0,
            color: 'customGreen.dark',
            width: '100%',
            maxWidth: '30rem',
            mx: 'auto',
            textAlign: 'left',
        }}>
            <AccessTimeRoundedIcon sx={{ fontSize: compact ? 20 : 24, color: 'inherit', flexShrink: 0 }} />
            <Box sx={{ minWidth: 0 }}>
                <Typography component="p" level={compact ? 'body-xs' : 'body-sm'} sx={{ color: 'inherit', fontWeight: 600 }}>
                    {t('minimumStayDetail.minimum', { count: parkingPeriod.durationHours })}
                </Typography>
                <Typography component="p" level={compact ? 'body-xs' : 'body-sm'} sx={{ color: 'inherit' }}>
                    {getGarageParkingEndMessage(parkingPeriod, t, 'minimumStayDetail')}
                </Typography>
            </Box>
        </Box>
    )
}
